export const CHARGE_SUMMARIES_FETCH = "charge_management/charge_summaries_fetch"
export const CHARGE_SUMMARIES_FETCH_SUCCESS =
    "charge_management/charge_summaries_fetch_success"
export const CHARGE_SUMMARIES_FETCH_FAILURE =
    "charge_management/charge_summaries_fetch_failure"
export const CHARGE_SUMMARIES_DETAILS_FETCH =
    "charge_management/charge_details_fetch"
export const CHARGE_SUMMARIES_DETAILS_FETCH_SUCCESS =
    "charge_management/charge_details_fetch_success"
export const CHARGE_SUMMARIES_DETAILS_FETCH_FAILURE =
    "charge_management/charge_details_fetch_failure"

export const UPDATE_SELECTED_SUMMARY =
    "charge_management/update_selected_summary"
export const CLEAR_SELECTED_SUMMARY = "charge_management/clear_selected_summary"
